import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { useScene } from '../context/SceneContext'
import { useConfig } from '../context/ConfigContext'
import {
  ViolationBlock,
  VIOLATION_BADGE_OFFSET_X,
  violationBadgeWidth,
  hasViolationMarker,
} from '../blocks/ViolationBlock'
import { placeMarkerSpan } from '../blocks/PlaceBlock'
import { LayerWrapper } from './LayerWrapper'
import { MarkerSpan, resolveHorizontalOffsets } from './pointLanes'
import { LayerProps } from './types'

const ViolationsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const scene = useScene()
  const { violations, places } = useTimelineData()
  const { simpleMode } = useConfig()

  const offsets = React.useMemo(() => {
    const blocked: MarkerSpan[] = simpleMode
      ? []
      : (places || []).map((place) =>
          placeMarkerSpan(place, scene.timeToX(place.startTime)),
        )

    const boxes = violations.map((violation, index) => {
      if (!hasViolationMarker(violation, scene.startTime)) return null
      const start =
        scene.timeToX(violation.startTime) + VIOLATION_BADGE_OFFSET_X
      return { start, end: start + violationBadgeWidth(index) }
    })

    return resolveHorizontalOffsets(boxes, blocked, { maxX: scene.width })
  }, [violations, places, simpleMode, scene])

  return (
    <LayerWrapper zIndex={zIndex}>
      {violations.map((item, index) => (
        <ViolationBlock
          key={index}
          violation={item}
          index={index}
          offsetX={offsets[index]}
        />
      ))}
    </LayerWrapper>
  )
}

export default ViolationsLayer
